"use client";

import { m as motion, useReducedMotion } from "framer-motion";
import { useState, type ReactNode } from "react";

import { RevealOnScroll } from "@/components/primitives/RevealOnScroll";

type Props = {
  title: string;
  description: string;
  icon: ReactNode;
  delay?: number;
};

export function ServiceCard({ title, description, icon, delay = 0 }: Props) {
  const prefersReduced = useReducedMotion();
  const [hovered, setHovered] = useState(false);

  return (
    <RevealOnScroll delay={delay}>
      <motion.div
        onPointerEnter={() => setHovered(true)}
        onPointerLeave={() => setHovered(false)}
        className="rounded-xl border bg-bg-elevated px-7 py-8"
        style={{
          borderColor: hovered
            ? "rgba(59,126,255,0.3)"
            : "var(--color-border-hairline)",
          background: hovered ? "var(--bg-raised)" : "var(--bg-elevated)",
          transition: "border-color .3s ease, background .3s ease",
        }}
        animate={{ y: prefersReduced ? 0 : hovered ? -4 : 0 }}
        transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
      >
        <div
          className="mb-6 grid h-11 w-11 place-items-center rounded-[10px] text-brand-azure"
          style={{
            background: "var(--accent-soft)",
            border: "1px solid rgba(59,126,255,0.3)",
          }}
        >
          {icon}
        </div>

        <h3
          className="mb-[10px] font-display text-[22px] font-bold"
          style={{ letterSpacing: "-0.02em" }}
        >
          {title}
        </h3>
        <p className="m-0 text-[15px] leading-relaxed text-fg2">
          {description}
        </p>
      </motion.div>
    </RevealOnScroll>
  );
}
